import { useMemo } from "react";

// ONE factual badge per job card — left results list only (never in the details pane).
// Every rule requires real, current job data; missing or unreliable data = no badge.
// We never infer application activity or imply better odds for early applicants.
const STYLES = {
  "Closing soon": "bg-amber-100 text-amber-800 border-amber-300",
  "Posted today": "bg-blue-600 text-white border-blue-600",
  "New this week": "bg-emerald-50 text-emerald-700 border-emerald-300",
  "Featured": "bg-yellow-100 text-yellow-800 border-yellow-300",
  "Employer details available": "bg-zinc-100 text-zinc-600 border-zinc-200",
};

export default function JobStatusNotes({ job, isExt = false, maskedEmployer = false }) {
  const note = useMemo(() => {
    if (!job) return null;
    const nowT = Date.now();
    // closing date: a genuine expiry/closing date that is actually approaching
    const closeRaw = job.expires_at || job.close_date || null;
    const closes = closeRaw ? new Date(closeRaw).getTime() : null;
    const daysToClose = closes && !Number.isNaN(closes) ? (closes - nowT) / 864e5 : null;
    if (daysToClose !== null && daysToClose >= 0 && daysToClose <= 5) return "Closing soon";
    // posting date: live_at/created_at is the ORIGINAL posting date across every source
    // (partner importers store the feed's own publication date, never the import time)
    const posted = new Date(job.live_at || job.created_at || 0).getTime();
    const ageH = posted && !Number.isNaN(posted) ? (nowT - posted) / 36e5 : null;
    if (ageH !== null && ageH >= 0 && ageH <= 24) return "Posted today";
    if (ageH !== null && ageH >= 0 && ageH <= 168) return "New this week";
    if (job.featured) return "Featured";
    if (!maskedEmployer && (job.company_name || "").trim()) return "Employer details available";
    return null;
  }, [job, isExt, maskedEmployer]);

  if (!note) return null;
  return (
    <span data-testid={`job-note-${note.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-full border ${STYLES[note]}`}>
      {note}
    </span>
  );
}
